import * as lib from './lib';
import * as config from './config';

export * as rwPassengersDataTypes from './types';
export const rwPassengersData = {
  lib,
  config,
};
